
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summer-camp-shipping",
      function () {
        return require("private-next-pages/summer-camp-shipping/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summer-camp-shipping"])
      });
    }
  